export const RAZORPAY_RESET_STATE = 'RAZORPAY_RESET_STATE';
export const RAZORPAY_CURRENT_ITEM = 'RAZORPAY_CURRENT_ITEM';

export const RAZORPAY_REQUEST_LOADING = 'RAZORPAY_REQUEST_LOADING';
export const RAZORPAY_REQUEST_SUCCESS = 'RAZORPAY_REQUEST_SUCCESS';
export const RAZORPAY_REQUEST_FAILED = 'RAZORPAY_REQUEST_FAILED';

export const RAZORPAY_CURRENT_ACTION = 'RAZORPAY_CURRENT_ACTION';
export const RAZORPAY_RESET_ACTION = 'RAZORPAY_RESET_ACTION';